import { createGlobalStyle } from 'styled-components';
import { componentToken } from './utils';

const GlobalStyle = createGlobalStyle`
  *,
  *:before,
  *:after {
    box-sizing: border-box;
    font-family: ${componentToken('globalStyle.fontFamily')};
    font-feature-settings: 'ss01' on, 'ss03' on, 'ss05' on, 'liga' off, 'clig' off;
  }

  code,
  pre,
  kbd,
  samp,
  tt {
    font-family: ${componentToken('globalStyle.codeFontFamily')};
  }

  body {
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-y: hidden;
  }

  #root {
    width: 100vw;
    height: 100vh;
  }

  * {
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
  }

  *:hover {
    scrollbar-color: ${componentToken(
      'globalStyle.scrollbarThumb',
    )} transparent;
  }

`;

export default GlobalStyle;
